import script from "./InputEmail.vue?vue&type=script&lang=js"
export * from "./InputEmail.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__